<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div scadenzario-form-add #formScadenzario (onReturn)="manageModal($event)" (lastID)="getLastID($event)"(onScadenzaInseritaForAuto)="eventoScadenzaInseritaForAuto($event)"></div>
		</div>
	</div>
</div>